import {
    /** FETCH GETCITIESBYDISTRICTNAME  */
    FETCH_GETCITIESBYDISTRICTNAME_FULFILLED,
    FETCH_GETCITIESBYDISTRICTNAME_REJECTED,
    FETCH_GETCITIESBYDISTRICTNAME_PENDING,
    RESET_GETCITIESBYDISTRICTNAME,
  } from "../../actions/payment/getCitiesByDistrictName";
  const initialState = {
    done: false,
    error: false,
    spinner: false,
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETCITIESBYDISTRICTNAME_PENDING:
        return {
          done: false,
          error: false,
          spinner: true,
        };
      case FETCH_GETCITIESBYDISTRICTNAME_FULFILLED:
        return {
          ...state,
          getCitiesByDistrictName: action.payload,
          done: true,
          error: false,
          spinner: false,
        };
      case FETCH_GETCITIESBYDISTRICTNAME_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner: false,
        };
      case RESET_GETCITIESBYDISTRICTNAME:
        return {
          initialState,
          done: false,
          error: false,
          spinner: false,
        };
      default:
        return state;
    }
  };
  